export const GET_DETAILS = 'GET_DETAILS'
export const GET_DETAILS_LOADING = 'GET_DETAILS_LOADING'
export const UPDATE_POST = 'UPDATE_POST'
